import { render } from "./ConfeRence.vue?vue&type=template&id=e153f14a&scoped=true&ts=true"
import script from "./ConfeRence.vue?vue&type=script&lang=ts"
export * from "./ConfeRence.vue?vue&type=script&lang=ts"

import "./ConfeRence.vue?vue&type=style&index=0&id=e153f14a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e153f14a"]])

export default __exports__